import React from "react";
import { Box, MainText } from "app/components/common";
import ProgressInfosBox from "../ProgressScreen/Components/ProgressInfosBox";
import CircleArrowIcon from "app/components/Icons/CircleArrowIcon";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";

interface Props {
  text: string;
  legend?: string;
  isUp?: boolean;
}

const CircleInfoBox = ({ text, legend = "", isUp = true }: Props) => {
  return (
    <ProgressInfosBox
      info={
        <Box flexDirection="row">
          <MainText variant="l6-bold" color="neutral.900" marginRight="xxs">
            {text}
          </MainText>
          <CircleArrowIcon
            style={{
              transform: [
                {
                  rotate: isUp ? "180deg" : "0deg",
                },
              ],
            }}
            color={
              isUp
                ? theme.colors["system.green.900"]
                : theme.colors["system.red.900"]
            }
          />
        </Box>
      }
      description={legend}
    />
  );
};

export default CircleInfoBox;
